// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Tooltip = require("../../reason/common/Tooltip.bs.js");
var ViewStack = require("../../reason/common/ViewStack.bs.js");
var Icon__Jsx3 = require("../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../reason/common/Theme/Theme__Color__Vars.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var UseShouldShowPropertyDetails = require("../common/Hooks/UseShouldShowPropertyDetails.bs.js");
var PropertyLocationForCard_propertyV5_graphql = require("../../__generated__/PropertyLocationForCard_propertyV5_graphql.bs.js");

var convertFragment = PropertyLocationForCard_propertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyLocationForCard_propertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyLocationForCard_propertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyLocationForCard_propertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyLocationForCard_propertyV5_graphql.node, convertFragment, fRef);
}

var PropertyFragment_visibilityReason_decode = PropertyLocationForCard_propertyV5_graphql.Utils.visibilityReason_decode;

var PropertyFragment_visibilityReason_fromString = PropertyLocationForCard_propertyV5_graphql.Utils.visibilityReason_fromString;

var PropertyFragment = {
  visibilityReason_decode: PropertyFragment_visibilityReason_decode,
  visibilityReason_fromString: PropertyFragment_visibilityReason_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyLocationForCard(props) {
  var property = use(props.property);
  var shouldShowPropertyDetails = UseShouldShowPropertyDetails.use(property.fragmentRefs);
  var headingClassName = TailwindMerge.twMerge([
        "text-zinc-700 text-lg font-medium leading-tight",
        Core__Option.getOr(props.className, "")
      ]);
  var match = property.propertyLocation;
  var tmp;
  if (shouldShowPropertyDetails) {
    switch (match.__typename) {
      case "PropertyLocationWithHiddenAddress" :
          tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx("h3", {
                        children: match.locationDisplay,
                        className: headingClassName
                      }),
                  JsxRuntime.jsxs(ViewStack.make, {
                        space: "xs",
                        alignItems: "center",
                        flexDirection: "row",
                        children: [
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "Lock",
                                      color: Theme__Color__Vars.tussock
                                    })
                              }),
                          JsxRuntime.jsx("div", {
                                children: "Contact agent for address",
                                className: "text-zinc-600 text-lg font-normal"
                              })
                        ]
                      })
                ]
              });
          break;
      case "PropertyLocationWithVisibleAddress" :
          var locationDisplay = match.locationDisplay;
          var address = match.address;
          var exit = 0;
          var tmp$1 = match.visibilityRule;
          if ((tmp$1 === "VISIBLE_TO_ALL" || tmp$1 === "VISIBLE_TO_ACCOUNT_MEMBER" || tmp$1 === "VISIBLE_TO_TAN_STAFF") && tmp$1 === "VISIBLE_TO_ACCOUNT_MEMBER") {
            tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                  children: [
                    JsxRuntime.jsx("h3", {
                          children: locationDisplay,
                          className: headingClassName
                        }),
                    JsxRuntime.jsxs(ViewStack.make, {
                          space: "xs",
                          alignItems: "center",
                          flexDirection: "row",
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                        icon: "Lock",
                                        color: Theme__Color__Vars.tussock
                                      })
                                }),
                            JsxRuntime.jsx(Tooltip.make, {
                                  ariaLabel: address + " (only visible to you)",
                                  label: address,
                                  children: JsxRuntime.jsx("div", {
                                        children: "Hidden Address",
                                        className: "text-zinc-600 text-lg font-normal relative underline decoration-dotted"
                                      })
                                })
                          ]
                        })
                  ]
                });
          } else {
            exit = 1;
          }
          if (exit === 1) {
            tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
                  children: [
                    JsxRuntime.jsx("h3", {
                          children: locationDisplay,
                          className: headingClassName
                        }),
                    JsxRuntime.jsx("div", {
                          children: address,
                          className: "text-zinc-600 text-lg font-normal"
                        })
                  ]
                });
          }
          break;
      case "__unselected" :
          tmp = UnselectedUnionMemberError.raise(match._0);
          break;
      
    }
  } else {
    var exit$1 = 0;
    var locationDisplay$1;
    switch (match.__typename) {
      case "PropertyLocationWithHiddenAddress" :
          locationDisplay$1 = match.locationDisplay;
          exit$1 = 1;
          break;
      case "PropertyLocationWithVisibleAddress" :
          locationDisplay$1 = match.locationDisplay;
          exit$1 = 1;
          break;
      case "__unselected" :
          tmp = UnselectedUnionMemberError.raise(match._0);
          break;
      
    }
    if (exit$1 === 1) {
      tmp = JsxRuntime.jsx("h3", {
            children: locationDisplay$1,
            className: headingClassName
          });
    }
    
  }
  return JsxRuntime.jsx(ViewStack.make, {
              space: "xs",
              children: Caml_option.some(tmp)
            });
}

var make = PropertyLocationForCard;

exports.PropertyFragment = PropertyFragment;
exports.make = make;
/* Tooltip Not a pure module */
